// src/components/CustomTabs/CustomTabs.jsx
import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    backgroundColor: 'transparent', // Hide the default indicator line
  },
  backgroundColor: theme.palette.background.paper,
  paddingLeft: theme.spacing(2), // Add spacing on the left side
  '& .MuiTabs-flexContainer': {
    position: 'relative', // Needed to position the pseudoelement
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: '10%',
      borderBottom: '1px solid #dee2e6', // Continuous line across the tabs
      zIndex: 0,
    },
  },
}));

const CustomTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: '0.75rem', // Smaller font size for the tabs
  color: '#555',
  marginRight: '0', // Remove space between tabs
  padding: theme.spacing(0.5, 1),
  minHeight: '42px', // Shorter tab height
  '&.Mui-selected': {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold, // Bold text for selected tab
    backgroundColor: '#fff', // White background for the selected tab
    borderBottom: '1px solid transparent', // Remove the bottom border
    zIndex: 2, // Ensure the tab is above the pseudo-element line
  },
  '&:not(.Mui-selected)': {
    backgroundColor: 'rgba(224, 224, 224, 0.5)', // Subtler gray background for unselected tabs
    borderBottom: '1px solid #dee2e6', // Visible bottom border for unselected tabs
  },
  '&:hover': {
    //backgroundColor: 'rgba(224, 242, 255, 0.5)', // Light blue background on hover
    opacity: 1,
  },
  borderRadius: '4px 4px 0 0',
  border: '1px solid #dee2e6',
  borderBottom: 'none', // Merge seamlessly with the content area below
}));

const SettingsTabs = ({ value, onChange, showDependenciesTab }) => {
//  console.log("[CustomTabs] Active tab value in SettingsTabs:", value); // Ensure this logs 'basic' on initial render
  return (
    <Box sx={{ bgcolor: 'background.paper' }}>
      <CustomTabs value={value} onChange={onChange} aria-label="basic and advanced settings">
        <CustomTab label="Basic" value="basic" />
        <CustomTab label="Advanced" value="advanced" />
        {showDependenciesTab && <CustomTab label="Dependencies" value="dependencies" />}
      </CustomTabs>
    </Box>
  );
};

export default SettingsTabs;

